
/**
 * ToolBar constructor
 * @constructor editor.stage.toolbar.ToolBar
 */
fx.ns("desktop.common.toolbar", class ToolBar extends fx.Component{
    
	constructor(frameaction, model)
	{
		super();
	
		this._frameaction = frameaction;

		this.model = model;

		this.assets = fx.get("assets");

		this.factory = new desktop.common.toolbar.ToolBarFactory(model);

		this.visibleAtStart = false;

		this.on("updated", this._zoomUpdated, this.model.zoom);

	//	this.effect = "scale";
	}

	/**************** Getters / Setters *************/
	
	get currentElement()
	{
		return this._currentElement;
	}

	set currentElement(val)
	{
		if (this._currentElement)
			this.off("updated", this._onDataUpdated, this._currentElement.data);

		this._currentElement = val;
		
		/*if (this.buttons)
			this.buttons.removeAllChild(true);*/

		if (!this._currentElement || !this._currentElement.showActions)
		{
			this.hide();
		}
		else
		{
			if (!this._currentElement.showActions && !this._currentElement.editable)
				return;

			this.on("updated", this._onDataUpdated, this._currentElement.data);

			if ( this._buildButtons() )
			    this.show();
            else
                this.hide();
		}

	}


	/******************** Overrides  ************/


	show()
	{
		if (this.model.zoom.value < 100)
			return;

		super.show();

		if (this.visible)
		{
			this._resize();
			this._position();
		}

		this.removeClass("hidden");
	}

	create()
	{
		super.create();

		this.buttons = new fx.components.HBox("buttons");
		this.addChild(this.buttons, {width:"auto", height:"100%", left:5});
	}

	onReady()
	{
		super.onReady();

		this.on("click", this._onClick);
	}


	/**
	 * We override this function, so we can move up ToolBar when hidden.
	 * In order to avoid bug Board on scrollHeight (zoom 25%)
	 */
	hide()
	{
		super.hide();

		if (this.model.zoom.value < 100)
			this.css({left: 0, top: 0});

		this.addClass("hidden");
	}

	resize()
	{
		// nothing
	}

	position()
	{
		// nothing
	}
	
	_resize()
	{
		let width = 10, childs = this.buttons.getChilds();

		for (let i = 0; i < childs.length; i++)
		{
			if (!childs[i].visible)
				continue;
			
			if (childs[i].css("display") != "none")
				width += childs[i].realWidth;

			if (childs[i].hasClass("separator") && childs[i].css("display") != "none") // separator
				width+=1;
			
		}
		
		this._viewport.width = width;
		this._viewport.height = 62.5;
		super.resize();
	}

	_position(e)
	{	
		if (!this._currentElement)
			return;
		
		let boundingRect, parentOffset,left,top;
		if(!this._currentElement.editable && this._currentElement.showActions)
		{
			boundingRect = this._currentElement.node.getBoundingClientRect();
		}
		else
		{
			boundingRect = this._frameaction.border.getBoundingClientRect();
		}

		parentOffset = fx.dom.offset(this.parent.node);
		boundingRect.y = boundingRect.top  - parentOffset.top;
		boundingRect.x = boundingRect.left - parentOffset.left;

		top = boundingRect.y + boundingRect.height + 20 + this.parent.node.scrollTop;
		left = boundingRect.x + ( boundingRect.width - this.width() ) / 2;

		if (left < 0)
			left = 10;
		else
		if ( left + this.width()  > this.parent.realWidth )
			left =  this.parent.realWidth -  this.width() - 30 ;

		if (top < 0) 
			top = 0;
		else
		if (top + this.height() > this.parent.realHeight + this.parent.node.scrollTop)
				top = this.parent.realHeight - this.height() - 10 + this.parent.node.scrollTop;
	
		if (e && e.type == "text-changed")
		{
			this._left = left;
			this._top = top;
			this.delay( this._moveToolBar, 500);
		}
		else
			this.css({left : left, top : top});
	}

	_moveToolBar()
	{
		this.css({left : this._left, top : this._top});
	}

	/******************* Events ***************/

	_onClick(event)
	{
			if (!this._currentElement || !this._currentElement.data)
				return;

			let target = fx.dom.parent(event.target, ".ToolBarAction");
			
			if (target)
			{
				let command = this._findCommand(target.getAttribute("id"));
				if (command && command.event)
					this._currentElement.trigger(command.event);
			}

			//this._updateButtons( !fx.dom.parent(event.currentTarget, ".ToolBar") );
	}

	_onDataUpdated(e)
	{
		if (e.action.impacts("content"))
			this._position({type : "text-changed"});
		else
		if (e.action.type != "delete")
			this.delay(this._updateButtons, 50); // delay in case of action propagate to parents
	}

	_zoomUpdated(action)
	{
		if (this.model.zoom.value < 100)
			this.css({left: 0, top: 0});
	}



	/************************************************/

	_buildButtons()
	{
		if (this.buttons)
			this.buttons.removeAllChild(true);

		if (!this._currentElement || !this._currentElement.allcommands) return false;
		
		for (let i =0; i < this._currentElement.allcommands.length; i++)
		{
			let command = this._currentElement.allcommands[i];

			/*if (command.visible !== undefined && !command.visible)
				continue;*/

			this.buttons.addChild( this.factory.create(command, this.currentElement, this), command.type ? {} : {top:-5} );	
		}
		
        if (this._currentElement.allcommands.length > 0)
        {
		    this._updateButtons(true);
            return true;
        }
        else
            return false;
	}

	_updateButtons(update)
	{
		if (!this._currentElement) 
		{
			this.hide();
			return;
		}

		//if (update)
		//	this.css({opacity:0, transition:"none"});

		this._currentElement.updateCommands();

		let childs = this.buttons.getChilds();
		let allAlementBeforeSeparatorNotVisible = true;
		let separatorReached = false;
		let separator;
		for (let i = 0; i < childs.length; i++)
		{
			if (childs[i].classname == "separator")
			{
				separator = childs[i];
				separatorReached = true;
			}
				

			let command = this._findCommand(childs[i].id);
			
			if (command == null) continue;

			if (!separatorReached)
				allAlementBeforeSeparatorNotVisible = allAlementBeforeSeparatorNotVisible && !command.visible;

			if (command.visible !== undefined && !command.visible)
				childs[i].hide();
			else
				childs[i].show();

			if (command && command.disabled)
				childs[i].disable();
			else
				childs[i].enable();
		}

		// check if all buttons before separator are not visible, the hide separator
        /*if (separator)
		    separator.css("display", allAlementBeforeSeparatorNotVisible ? "none" : "inline-block");*/

		if (update)
			this.updateDisplay();
		else
			this._resize();
	
	}

	_findCommand(id)
	{
		if (!this._currentElement || !this._currentElement.allcommands)
			return;

		for (let i = 0; i < this._currentElement.allcommands.length; i++)
		{
			if (this._currentElement.allcommands[i].id == id)
				return this._currentElement.allcommands[i];
		}
	}

	
});